import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { formatPhoneNumber, getCustomerLoyaltyId } from "helpers";
import { getCustomerProfile } from "endpoints/profile";

const useCustomerBioData = () => {
  const [searchParams] = useSearchParams();
  const token = useMemo(
    () => searchParams.get("token") || searchParams.get("access_token"),
    [searchParams],
  );
  const accessNumber = useMemo(
    () =>
      searchParams.get("access_number") ||
      searchParams.get("phone_number") ||
      searchParams.get("phone"),
    [searchParams],
  );

  const [profile, setProfile] = useState(null);
  const [isLoadingProfile, setIsLoadingProfile] = useState(!!token);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    let isMounted = true;
    setIsLoadingProfile(true);
    const loyaltyId = getCustomerLoyaltyId(token);

    getCustomerProfile(token, loyaltyId)
      .then((res) => {
        if (!isMounted) return;
        const fetchedProfile =
          res?.data?.data?.profile || res?.data?.data || res?.data;
        if (fetchedProfile) {
          setProfile(fetchedProfile);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (isMounted) setIsLoadingProfile(false);
      });

    return () => {
      isMounted = false;
    };
  }, [token, navigate]);

  const initialPhoneNumber = useMemo(() => {
    return accessNumber
      ? formatPhoneNumber(accessNumber)
      : formatPhoneNumber(
          profile?.phone || profile?.phone_number || profile?.phoneNumber,
        );
  }, [
    accessNumber,
    profile?.phone,
    profile?.phone_number,
    profile?.phoneNumber,
  ]);

  const data = useMemo(
    () => ({
      firstName: profile?.first_name || profile?.firstName || "",
      lastName: profile?.last_name || profile?.lastName || "",
      middleName: profile?.middle_name || profile?.middleName || "",
      email: profile?.email || "",
      phoneNumber: initialPhoneNumber || "",
      gender: profile?.gender || "MALE",
      dob: profile?.date_of_birth || profile?.dob || "",
      businessName: "BashirMusa Enterprise",
      token,
    }),
    [profile, initialPhoneNumber, token],
  );

  const createBio = useCallback(() => {
    localStorage.setItem(`${process.env.REACT_APP_ACCESS_TOKEN_NAME}`, token);
    navigate("/app");
  }, [token, navigate]);

  return {
    data,
    createBio,
    isLoadingProfile,
  };
};

export default useCustomerBioData;
